import { useEffect } from 'react';
import { toast } from 'sonner';

const EDITABLE = 'input, textarea, [contenteditable=""], [contenteditable="true"]';

// Stops learners pasting (or dropping) text into answer boxes, chats and code editors; password fields stay pasteable
export const usePasteBlock = (enabled, apiRef) => {
    useEffect(() => {
        if (!enabled) return undefined;
        let lastToast = 0;
        let lastLog = 0;
        const block = (e) => {
            if (e.target?.type === 'password') return;
            e.preventDefault();
            e.stopPropagation();
            const now = Date.now();
            if (now - lastToast > 2500) {
                lastToast = now;
                toast.warning('Pasting is turned off. Please type your answer yourself.');
            }
            if (now - lastLog > 30000) {
                lastLog = now;
                apiRef.current.post('/focus-guard/paste-blocked', { page: window.location.pathname }).catch(() => {});
            }
        };
        const onDrop = (e) => {
            if (e.dataTransfer?.files?.length || !e.target?.closest?.(EDITABLE)) return;
            block(e);
        };
        const onBeforeInput = (e) => {
            if (e.inputType === 'insertFromPaste' || e.inputType === 'insertFromDrop') block(e);
        };
        document.addEventListener('paste', block, true);
        document.addEventListener('drop', onDrop, true);
        document.addEventListener('beforeinput', onBeforeInput, true);
        return () => {
            document.removeEventListener('paste', block, true);
            document.removeEventListener('drop', onDrop, true);
            document.removeEventListener('beforeinput', onBeforeInput, true);
        };
    }, [enabled, apiRef]);
};
